// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';

export class QuotePriceEscalation {
  readonly id: string;
  readonly quoteId: string;
  readonly escalationDate: DateTime;
  readonly kind: Enums.EscalationKind;
  readonly changeRatio: string | null;
  readonly flatChange: Currency | null;
  readonly appliedAt: string | null;
  readonly appliedBy: string | null;
  readonly appliedByName: string | null;
  readonly isProcessed: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.quoteId = data.quoteId === undefined ? NIL_UUID : data.quoteId;
    this.escalationDate = DateHelpers.ParseServerDate(data.escalationDate);
    this.kind = data.kind === undefined ? Enums.EscalationKind.Percentage : data.kind;
    this.changeRatio = data.changeRatio === undefined ? null : data.changeRatio;
    this.flatChange = (data.flatChange ?? null) === null ? null : NewCurrency(data.flatChange);
    this.appliedAt = data.appliedAt === undefined ? null : data.appliedAt;
    this.appliedBy = data.appliedBy === undefined ? null : data.appliedBy;
    this.appliedByName = data.appliedByName === undefined ? null : data.appliedByName;
    this.isProcessed = data.isProcessed === undefined ? false : data.isProcessed;
  }

  static zero(): QuotePriceEscalation {
    const zeroValues: ExcludeMethodsDeep<QuotePriceEscalation> = {
      id: NIL_UUID,
      quoteId: NIL_UUID,
      escalationDate: DateHelpers.ParseServerDate(DateHelpers.ZERO_DATE_STRING),
      kind: Enums.EscalationKind.Percentage,
      changeRatio: null,
      flatChange: null,
      appliedAt: null,
      appliedBy: null,
      appliedByName: null,
      isProcessed: false,
    };
    return new QuotePriceEscalation(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuotePriceEscalationWireFormat = {
  id: string;
  quoteId: string;
  escalationDate: string;
  kind: string;
  changeRatio: string | null;
  flatChange: CurrencyWireFormat | null;
  appliedAt: string | null;
  appliedBy: string | null;
  appliedByName: string | null;
  isProcessed: boolean;
};

type NewQuotePriceEscalationProps = PartialDeep<QuotePriceEscalation, { recurseIntoArrays: true }>;
export const NewQuotePriceEscalation: (
  props: NewQuotePriceEscalationProps,
) => QuotePriceEscalation = (props) => new QuotePriceEscalation(props);

type NewQuotePriceEscalationFromWireFormatProps = PartialDeep<
  QuotePriceEscalationWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuotePriceEscalationFromWireFormat: (
  props: NewQuotePriceEscalationFromWireFormatProps,
) => QuotePriceEscalation = (props) => new QuotePriceEscalation(props);
